// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout-module--container--2EaUW","header":"Layout-module--header--26_6V","footer":"Layout-module--footer--3vu9_","main":"Layout-module--main--1OIFf"};